import { SharedGridConfig } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.model";
import { Lead } from "./leads.models";

export class SetLeadFormGridConfig {
    static readonly type = '[Leads] Set Lead Form Grid Config';
    constructor(public payload: { gridUUID: string; secondGridConfig: SharedGridConfig; }) { };
}

export class GetLeads {
    static readonly type = '[Leads] Get Leads';
    constructor(public payload: { gridUUID: string; }) { };
}

export class SetLeadType {
    static readonly type = '[Leads] Set Lead Type';
    constructor(public payload: { leadType: string; }) { };
}

export class SetSelectedLead {
    static readonly type = '[Leads] Set Selected Lead';
    constructor(public payload: { _id: string, md5Checksum: string; }) { };
}

export class CreateLead {
    static readonly type = '[Leads] Create Lead';
}

export class DeleteLead {
    static readonly type = '[Leads] Delete Lead';
    constructor(public payload: Lead) { };
}

export class OnActionLead {
    static readonly type = '[Leads] On Action Lead';
}

export class GetLeadsForFormData {
    static readonly type = '[Leads] Get Leads For Form Data';
    constructor(public payload: string) { };
}

export class GetTobaccoTypes {
    static readonly type = '[Leads] Get Tobacco Types';
}

//** Leads Status Functions */
export class GetLeadsStatuses {
    static readonly type = '[Leads] Get Leads Statuses';
}

export class OnSetLeadStatus {
    static readonly type = '[Leads] On Set Lead Status';
}

export class GetTobaccoForms {
    static readonly type = '[Leads] Get Tobacco Forms';
}

//** WEBHOOKS */

export class UpdatedLeadWebhook {
    static readonly type = '[Lead] Document updated';
    constructor(readonly payload: any) { }
}